import Firebase from 'firebase/app'
import 'firebase/auth'
import axios from 'axios'

const state = {
  user: null,
};

const getters = {
  user: state => {
    return state.user;
  }
};

const mutations = {
  setUser: state => {
    state.user = Firebase.auth().currentUser;
  },
  setUserRoles: (state, payload) => {
    state.user.roles = payload['roles']
  },
};

const actions = {
  setUser: ({ commit, dispatch }) => {
    commit("setUser");
    dispatch('getUserRoles', {})

  },
  getUserRoles: ({ commit }) => {
    return new Promise((resolve, reject) => {

      // we get the token that can be verified at the server
      Firebase.auth().currentUser.getIdToken(/* forceRefresh */ true).then(function (idToken) {
        // Send token to backend via HTTPS
        axios.get('/userRoles', {
          params: { idToken: idToken }
        }).then(function (results) {
          commit("setUserRoles", results.data);
          resolve(results);
        }).catch(function (error) {
          if (error) {
            reject(new Error("cannot fetch user roles"));
          }
        });
      }).catch(function () {
        // Handle error
      });


    })
  }
};

export default {
  state,
  mutations,
  actions,
  getters,
  namespaced: true
};
